import {get, post} from '../router/http.js'


export default {
    info :(params) => {
		return get('/api/wordbook/info', params)
	},
    lists :(params) => {
		return get('/api/wordbook/list', params)
	},
    currentBook :(params) => {
		return get('/api/wordbook/current/book', params)
	},
    //获取单词本的进度
    getWordBookProgress :(params) => {
		return get('/api/wordbook/progress', params)
	},
    //获取单词本的组学习的单词
    getWordBookStudyWord :(params) => {
		return get('/api/wordbook/study/word', params)
	},
    joinBook :(params) => {
		return post('/api/wordbook/student/join', params)
	},
    currentModule :(params) => {
		return get('/api/wordbook/current/module', params)
	},
    getModuleList :(params) => {
        return get('/api/wordbook/module/list', params)
    },
    getModule :(params) => {
        return get('/api/wordbook/module/info', params)
    },
    startStudy :(params) => {
        return post('/api/wordbook/module/start', params)
    },
    getExamQuestion : (params) => {
        return get('/api/wordbook/module/question', params)
    },
    submitQuestion : (params) => {
        return post('/api/wordbook/question/submit', params)
    },
    getGroupExamAnalysis : (params) => {
        return get('/api/wordbook/exam/group/analysis', params)
    },
    getExamQuestionAnalysis : (params) => {
        return get('/api/wordbook/exam/group/analysis/question', params)
    },
    startExamQuestionByGroup : (params) => {
        return get('/api/wordbook/exam/group/question', params)
    },
    getExamLog : (params) => {
        return get('/api/wordbook/exam/log/list', params)
    },
    getWordBookCatalogTree : (params) => {
        return get('/api/wordbook/catalog/tree', params)
    },

}



// WEBPACK FOOTER //
// ./src/api/wordBook.js